/**
 * VITE_SNAP_ID may include a version suffix, e.g.:
 *   npm:@taker007/crypto-guardian-snap@1.0.2
 *
 * MetaMask wallet_requestSnaps expects the snap origin WITHOUT version as the
 * key, and the version inside the value object:
 *   { "npm:@taker007/crypto-guardian-snap": { version: "1.0.2" } }
 *
 * We split them here so useSnap can pass the correct structure.
 */
const raw = import.meta.env.VITE_SNAP_ID || '';

function parseSnapId(id: string): { origin: string; version?: string } {
  // Match npm:@scope/name@version or npm:name@version
  const match = id.match(/^(npm:(?:@[^/]+\/)?[^@]+)(?:@(.+))?$/);
  if (match) {
    return { origin: match[1], version: match[2] };
  }
  return { origin: id };
}

const parsed = parseSnapId(raw);

/** Snap origin without version — used as the key in wallet_requestSnaps */
export const SNAP_ORIGIN = parsed.origin;

/** Pinned version (if any) — used in the value object of wallet_requestSnaps */
export const SNAP_VERSION = parsed.version;

/** Full SNAP_ID with version — used for wallet_getSnaps detection */
export const SNAP_ID = raw;
